import { useState } from 'react';
import MultiCheckbox from '../general/MultiCheckbox';
import { useGame } from '../../context/GameContext';

export default function SuggestionsCheckbox({ prompt = '', suggestions = [] }) {
  const { saveIntermissionSelections } = useGame();

  const optionsSuggestions = suggestions.map((item) => ({
    value: item.suggestion,
    label: `${prompt} ${item.suggestion}`,
  }));

  const optionsSuggestionsSmall = suggestions.map((item) => ({
    value: item.suggestion,
    label: item.suggestion,
  }));

  const [selected, setSelected] = useState([]);

  const handleChange = (next) => {
    setSelected(next);
    saveIntermissionSelections(next);
  };

  return (
    <div className="pl-3 pr-4">
      <div className="hidden sm:flex">
        <MultiCheckbox
          options={optionsSuggestions}
          selected={selected}
          onChange={handleChange}
          name="example"
        />
      </div>
      <div className="sm:hidden flex">
        <MultiCheckbox
          options={optionsSuggestionsSmall}
          selected={selected}
          onChange={handleChange}
          name="example"
        />
      </div>
    </div>
  );
}
